import classes from "./PendingOrder.module.css";
import OrderDetails from "../../OrderDetails/OrderDetails";

const PendingOrder = (props) => {
  const { order } = props;
  const { orderId, discount, subTotal, deliveryFees, skuList, bundleList } =
    order;

  return (
    <li className={classes["pending-order-list-item"]}>
      <OrderDetails
        id={orderId}
        total={subTotal - discount}
        skus={skuList}
        bundles={bundleList}
        deliveryFees={deliveryFees}
      />
    </li>
  );
};

export default PendingOrder;
